import * as React from 'react';
import { Room } from '../../../../../models/hotel-room-types';
import { RoomInfoContent } from '../RoomInfoContent';
import Portal from 'sletat-ui-components2/dist/components/Portal';
import SidePanel from 'sletat-ui-components2/dist/components/SidePanel';

export interface RoomCardSidePanelProps {
  room: Room;
  closeSidePanel: () => void;
}

export const RoomCardSidePanel = ({
    room,
    closeSidePanel,
}: RoomCardSidePanelProps) => {

    return (
      <Portal>
        <SidePanel
            scrollContent={true}
            title="Подробнее о номере"
            onClose={closeSidePanel}
            isOpen={true}
        >
          <RoomInfoContent room={room} />
        </SidePanel>
      </Portal>
    );
};
